<template>
  <div class="document">
    <icon-square-document></icon-square-document>
    <span>{{ document.name }}</span>
    <icon-close
      style="margin-left: 10px; cursor: pointer"
      @click="deleteFile"
    ></icon-close>
  </div>
</template>

<script>
export default {
  emits:['deleteFile'],
  props: {
    document: {
      required: true
    },
  },
  methods: {
    deleteFile() {
      this.$emit("deleteFile");
    },
  },
};
</script>

<style scoped>
span {
  font-family: "Lato";
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  line-height: 22px;
  color: #1c1363;
  margin-left: 10px;
}
.document {
  display: inline-flex;
  align-items: center;
  margin-right: 20px;
}
</style>